import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@mm/components';
import { usePromoterCRUDActions } from '@mm/state/actions/PromoterCRUDActions';
import { PromoterModel } from '@mm/state/model/PromoterModel';
import { chatWidgetTroubleshootingLastResultSelector } from '@mm/state/selectors/chatWidgetTroubleshootingSelectors';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import {
  ChatWidgetTroubleshootingToolResultTypes,
  Result,
} from '../ChatWidgetTroubleshootingToolResult';
import { useWhitelabelConfig } from '@mm/hooks/src/use-whitelabel-config';

type Props = {
  runDiagnostic: (updatedPromoter?: PromoterModel) => Promise<void>;
  promoter?: PromoterModel;
  isXRay?: boolean;
};
export const usePromoterActiveResult = (props: Props): Result => {
  const { promoter, runDiagnostic, isXRay } = props;
  const result = useSelector(chatWidgetTroubleshootingLastResultSelector);
  const botId = useSelector(activeChatbotIdSelector);
  const [activating, setActivating] = useState(false);

  const promoterCRUDActions = usePromoterCRUDActions();

  const { pixelName: whitelabelPixelName } = useWhitelabelConfig();
  const pixelName = whitelabelPixelName
    ? `${whitelabelPixelName} Lead Generator`
    : 'X-Ray Lead Generation Pixel';

  if (!promoter || !result || result.localTests.promoterActive === undefined) {
    return;
  }

  const activatePromoter = async () => {
    setActivating(true);
    const updatedPromoter = { ...promoter, active: true };
    await promoterCRUDActions.update(botId, updatedPromoter);
    await runDiagnostic(updatedPromoter);
    setActivating(false);
  };

  if (result.localTests.promoterActive) {
    return {
      result: 'ok',
      type: ChatWidgetTroubleshootingToolResultTypes.PromoterActiveResult,
      description: isXRay ? `${pixelName} is active` : 'Chat widget is active',
    };
  }
  return {
    result: 'error',
    type: ChatWidgetTroubleshootingToolResultTypes.PromoterActiveResult,
    description: (
      <>
        {isXRay ? `${pixelName} is not active` : ' Chat widget is not active'}
        <Button onClick={activatePromoter} disabled={activating}>
          {isXRay ? `Activate ${pixelName}` : 'Activate Chat Widget'}
        </Button>
      </>
    ),
  };
};
